var Marker = require('../../lib/markers/marker.js');
var Deletism = require('../../lib/markers/deletism.js');
var Undeletism = require('../../lib/markers/undeletism.js');
var Copier = require('../../lib/markers/copier.js');
var Columnator = require('../../lib/columnator.js');
var IndexView = require('../../lib/index-view.js');

module.exports = function() {
    new IndexView();

    var marker = new Marker('categories');

    new Copier(marker)
    new Deletism(marker);
    new Undeletism(marker);

    new Columnator();
};